module.exports = __webpack_public_path__ + "static/media/img14.9112feac.png";